import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Label } from 'components/atoms/label';
import { Button as ButtonAtom } from 'components/facade/button';
import { useTranslation } from 'hooks/use-translation';
var DatePickerType = /*#__PURE__*/ function(DatePickerType) {
    DatePickerType["Range"] = "range";
    DatePickerType["Single"] = "single";
    return DatePickerType;
}(DatePickerType || {});
const Button = styled(ButtonAtom)`
  border: 0;
  height: auto;
  padding: 0;

  &:hover {
    background: none !important;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
const ClearButton = styled(Button)`
  color: var(--error-color);
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: var(--red-70);
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: var(--spacing-04) var(--spacing-04) var(--spacing-02)
    var(--spacing-04);
`;
const PickTodayTomorrowWrapper = styled.div`
  margin-bottom: var(--spacing-03);
`;
const ModifyPickerTypeWrapper = styled.div`
  flex: 1;
  margin-bottom: var(--spacing-03);
  min-width: 240px;
`;
const DoneWrapper = styled.div`
  padding: var(--spacing-03);
  ${ButtonAtom} {
    width: 100%;
    justify-content: center;
  }
`;
const ClearDateWrapper = styled.div`
  margin-bottom: var(--spacing-03);
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
export const DueDatePickerFooter = ({ footerText, canChooseStartDate, useAsStartDatePicker, disallowSingleDate, hideModifyPicker = false, hideClearDate = false, type, onPickToday, onPickTomorrow, onClear, modifyPickerType, onDone, isTodayDisabled = false, isTomorrowDisabled = false })=>{
    const defaultFooterText = useTranslation('due_date.action');
    const finalFooterText = footerText !== null && footerText !== void 0 ? footerText : defaultFooterText;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !disallowSingleDate && !hideModifyPicker ? /*#__PURE__*/ _jsx(Wrapper, {
                children: /*#__PURE__*/ _jsx(Label, {
                    children: useAsStartDatePicker ? /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "start_date.action"
                    }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: finalFooterText
                    })
                })
            }) : null,
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    !disallowSingleDate ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(PickTodayTomorrowWrapper, {
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        type: "link",
                                        onClick: onPickToday,
                                        "data-cy": "due-date-picker.today",
                                        disabled: isTodayDisabled,
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "today"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "separator"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        type: "link",
                                        onClick: onPickTomorrow,
                                        "data-cy": "due-date-picker.tomorrow",
                                        disabled: isTomorrowDisabled,
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "tomorrow"
                                        })
                                    })
                                ]
                            }),
                            hideModifyPicker ? null : /*#__PURE__*/ _jsx(ModifyPickerTypeWrapper, {
                                children: canChooseStartDate && (type === "single" ? /*#__PURE__*/ _jsx(Button, {
                                    type: "link",
                                    onClick: modifyPickerType,
                                    "data-cy": "due-date-picker.add-start-and-end-date",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "due_date.range.action"
                                    })
                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "separator"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "link",
                                            onClick: modifyPickerType,
                                            children: useAsStartDatePicker ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                                id: "start_date.action"
                                            }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                                id: finalFooterText
                                            })
                                        })
                                    ]
                                }))
                            })
                        ]
                    }) : null,
                    hideModifyPicker || hideClearDate ? null : /*#__PURE__*/ _jsx(ClearDateWrapper, {
                        children: /*#__PURE__*/ _jsx(ClearButton, {
                            danger: true,
                            type: "text",
                            onClick: onClear,
                            "data-cy": "due-date-picker.clear-dates",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "clear_dates"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DoneWrapper, {
                children: /*#__PURE__*/ _jsx(ButtonAtom, {
                    type: "tertiary",
                    onClick: ()=>onDone(),
                    "data-cy": "due-date-picker.done",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "done"
                    })
                })
            })
        ]
    });
};
